module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraLight.220502d3.ttf";